import axios from 'axios';
import qs from 'qs';

import { API_URL } from '@source/constants/api';
import { TRegionKey } from '@source/interface';
import { WHOLESALE_AXIOS_USER_AUTH } from './UserProfile';

export default {
  getWorkShopServices: (country: TRegionKey, payload: Record<string, any>) => {
    const queryString = qs.stringify(payload);
    const dataQueryPath = API_URL(country).dataQuery;
    return axios.get(`${dataQueryPath}/workshop_services?${queryString}`);
  },
  getCarroExclusiveFilters: (country: TRegionKey, payload?: Record<string, any>) => {
    const queryString = qs.stringify(payload);
    const dataQueryPath = API_URL(country).dataQuery;
    return axios.get(`${dataQueryPath}/filters/carro_exclusives?${queryString}`);
  },
  getWorkShopLocations: (country: TRegionKey, payload?: Record<string, any>) => {
    const dataQueryPath = API_URL(country).dataQuery;
    return axios.get(`${dataQueryPath}/locations`, { params: payload });
  },
  createWorkshopTicket: (country: TRegionKey, payload: Record<string, unknown>, isAuthenticated?: boolean) => {
    const dataQueryPath = API_URL(country).workshopTickets;
    if (isAuthenticated) {
      return WHOLESALE_AXIOS_USER_AUTH.post(`${dataQueryPath}`, payload);
    }
    return axios.post(`${dataQueryPath}`, payload);
  },
};
